import React from "react";
import style from "./Footer.module.css";
import { NavLink } from "react-router-dom";

const Footer: React.FC = () => (
  <div className={style.Content}>
    <NavLink
      key={"licence"}
      exact
      to={"/licence"}
      className={style.MenuItem}
      style={{ textDecoration: "none" }}
    >
      Licencje
    </NavLink>
    <NavLink
      key={"copy"}
      exact
      to={"/copy"}
      className={style.MenuItem}
      style={{ textDecoration: "none" }}
    >
      Regulamin
    </NavLink>
    
    <NavLink
      key={"policy"}
      exact
      to={"/policy"}
      className={style.MenuItem}
      style={{ textDecoration: "none" }}
    >
      Polityka Prywatności
    </NavLink>
    {/* <NavLink
      key={""}
      exact
      to={"/"}
      className={style.MenuItem}
      style={{ textDecoration: "none" }}
    >
      Copyright &copy;2026
    </NavLink> */}
  </div>
);
export default Footer;
